export const GEOMETRY_STORAGE_KEY = 'xm_helpMenuUndockedGeometry';

export const MAX_HEIGHT = 20_000;
export const MIN_HEIGHT = 460;
export const MAX_WIDTH = 20_000;
export const MIN_WIDTH = 480;
